import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import { CenterCourse } from '../../../lib/types/models/center-course/center-course'
import { encodeNestedObject } from '../../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export function getCenterCourses(id: number, input: PaginationRequest = {}) {
  return restApiClient
    .url(
      encodeNestedObject<PaginationRequest>(
        constructApiUrl(API.centers.getCenterCourses.url, { id }),
        input
      )
    )
    .get<PaginationResponse<CenterCourse>>()
}
